import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import {
  OnsiteTemplatePreviewPayload,
  OnsiteTemplatePreviewQueryResponse,
} from 'sections/design/template-management/entities/templates';
import { useTemplateEditorDispatch, useTemplateEditorState } from '../context/UseTemplateEditorContext';
import { onsitePreviewTemplate } from '../utils/queries';

export const useOnsitePreview = () => {
  const { t } = useTranslation('designs');

  const dispatch = useTemplateEditorDispatch();
  const { template, compilationContext } = useTemplateEditorState();

  const { mutate: preview } = useMutation(onsitePreviewTemplate);

  return useCallback(() => {
    const precompiledTemplate = template?.template ?? '';

    const payload: OnsiteTemplatePreviewPayload = {
      siteId: template.siteId,
      template: precompiledTemplate,
      compilationContext: compilationContext.compilationContext,
    };

    const onSuccess = (data: OnsiteTemplatePreviewQueryResponse) => {
      localStorage.setItem('templateEditorPreview', data.compiled);

      dispatch({
        type: 'UPDATE_PREVIEW_INITIAL',
        payload: {
          compiledTemplate: data.compiled,
          precompiledLinks: [],
          transformedLinks: [],
          lastCompiledCompilationContext: data.compilationContext ?? compilationContext,
          lastCompiledTemplateBody: template.template,
        },
      });
    };

    preview({ payload, t }, { onSuccess });
  }, [compilationContext, dispatch, preview, t, template.template, template.siteId]);
};
